import { getRequest, postRequest, putRequest } from '../api-handler';
import { ProductDetailDto, ProductNRunDto } from './product';

export const ProductApi = {
  getById: (id: number) => getRequest<ProductDetailDto>(`/products/${id}`),
  createLot: (id: number) => putRequest<number>(`/products/${id}/lot`),
  createNorlabNo: (id: number) => putRequest<number>(`/products/${id}/norlab`),
  createNRun: (nRun: ProductNRunDto) =>
    postRequest<number>(`/products/nrun`, nRun)
};
